import { Box, TextField } from '@mui/material';
import List from 'widgets/list/list';
import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import { CurrentPage, LoadingProgramsList, ProgramsList } from 'entities/insurance-programs/selector';
import { fetchProgramsList } from 'entities/insurance-programs/actions/fetch-programs-list';
import { useForm } from 'shared/utils/hooks/useForm';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { setCurrentPage } from 'entities/insurance-programs';
import AllContractsList from 'widgets/all-contracts-list/AllContractsList';
import { IListProgram } from 'entities/insurance-programs/types/InsurancePrograms-interface';
import SearchIcon from '@mui/icons-material/Search';
import appStyles from 'app/providers/theme/App.module.css';
import Loader from 'shared/loader/Loader';


export const InsurancePrograms: FC = () => {
    const limit = 10;
    const dispatch = useAppDispatch();

    const listProgramsData = useAppSelector(ProgramsList);

    const currentPage = useAppSelector(CurrentPage)

    const isLoading = useAppSelector(LoadingProgramsList)

    const selectedContracts = {
        list: [],
    };

    const {
        formData,
        handleAutocompeteChange
    } = useForm(selectedContracts);

    const sortArray: string[] | [] = [];
    const [contractID, setContractID] = useState<string | string[]>([]);

    const [openSearch, setOpenSearch] = useState(false);
    const [searchQuery, setSearchQuery] = useState<string>('');

    const handleOpenSearch = () => setOpenSearch((prevState) => !prevState);

    useEffect(() => {
        const contract = (Array.isArray(contractID) ? contractID : [contractID]);
        dispatch(fetchProgramsList({ contractID: contract, sortArray }));
    }, [dispatch, limit, contractID]);


    const handleChildAction = useCallback((page: number) => {
        dispatch(setCurrentPage({ page }));
    }, [dispatch]);

    const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
        dispatch(setCurrentPage({ page: 1 }));
    }, [dispatch]);

    
    // const filtered = useMemo(() => {
    //     let filteredData = [...listProgramsData];

    //     if (searchQuery) {
    //         filteredData = filteredData.filter((item: IListProgram) =>
    //             item.PrintName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //             item.InsurerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //             item.ContractNumber.toLowerCase().includes(searchQuery.toLowerCase())
    //         );
    //     }

    //     return filteredData;
    // }, [listProgramsData, searchQuery]);

    // const paginatedProgram = useMemo(() => {
    //     const startIndex = (currentPage - 1) * limit;
    //     return filtered.slice(startIndex, startIndex + limit);
    // }, [currentPage, filtered]);

    const filtered = (() => {
        let filteredData = [...listProgramsData];
        if (searchQuery) {
            filteredData = filteredData.filter((item: IListProgram) =>
                item.PrintName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.InsurerName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.ContractNumber.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }
        return filteredData;
    })();

    const paginatedProgram = () => {
        const startIndex = (currentPage - 1) * limit;
        return filtered.slice(startIndex, startIndex + limit);
    };


    return (
        <>
            <Box className={appStyles.titleBox}>
                <h1>Программы страхования</h1>
            </Box>
            <AllContractsList
                formData={formData}
                handleAutocompeteChange={handleAutocompeteChange}
                setContractID={setContractID}
                multiple={true}
                name="list"
                reducerAction={setCurrentPage}
                disabled={isLoading}
            />

            {isLoading && (
                <Loader
                    title='Подготовка списка. Это займет несколько секунд.'
                />
            )}
            {!isLoading && (
                <>
                    <Box className={appStyles.iconSort}>
                        <span onClick={handleOpenSearch} className={`${openSearch ? appStyles.iconSelected : ''}`}><SearchIcon /></span>
                    </Box>
                    {openSearch && (
                        <TextField
                            label="Поиск"
                            variant="outlined"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            fullWidth
                            margin="normal"
                        />
                    )}
                    {listProgramsData.length > 0 && filtered.length > 0 ? (
                        <Box>

                            <Box sx={{
                                width: '100%',
                                overflow: 'hidden',
                                position: 'relative'
                            }}>
                                <List
                                    title={['Программа страхования', 'Номер договора', 'Начало действия', 'Окончание действия', 'Количество застрахованных', 'Страхователь']}
                                    data={paginatedProgram()}
                                    renderItem={(item: any) => (
                                        <>
                                            <Box><p>{item.PrintName}</p></Box>
                                            <Box><p>{item.ContractNumber}</p></Box>
                                            <Box><p>{item.StartDate}</p></Box>
                                            <Box><p>{item.EndDate}</p></Box>
                                            <Box><p>{item.InsuredQuantity}</p></Box>
                                            <Box><p>{item.InsurerName}</p></Box>
                                        </>
                                    )}
                                    renderPagination={filtered.length > 10}
                                    pageCount={Math.ceil(filtered.length / 10)}
                                    onAction={handleChildAction}
                                    currentPage={currentPage}
                                    pathnameProps="/insurance-programs/case/"
                                    link={true}
                                />
                            </Box>
                        </Box>
                    ) : (
                        <Box className={appStyles.infoBox}>
                            <p>Программы страхования не найдены</p>
                        </Box>
                    )}
                </>
            )}
        </>
    );
};

export default InsurancePrograms;